import React,{ useState,useEffect } from "react";
import { useNavigate,useParams } from "react-router-dom";
import { apiService } from "../services/apiService";
import { Form, Input, Select, Button } from "antd";
import { toast } from "react-toastify";

const AddUser = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [customers, setCustomers] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();
    const {id} = useParams(); // Get the ID from the URL parameters
    const [form] = Form.useForm(); // <-- Step 1: Create form instance


      // Fetch user data for editing
      const fetchUserData = async () => {
        try {
          // setLoading(true);
          const response = await apiService(`users/get-user-by-id/${id}`, "GET"); // Adjust endpoint as needed
          if (response.data) {
            form.setFieldsValue({
              name: response.data.username,
              email: response.data.email,
              // Add more fields if needed
            });
            // setSelectedCustomers([2,4]); // Assuming customers is an array of objects with 'id' property
             setSelectedCustomers(response.data.customers.map((customer) => customer.customer_id)); // Pre-select customers

            
          }
        } catch (error) {
          // message.error("Error fetching user data.");
        } finally {
          // setLoading(false);
        }
      };  
      useEffect(() => {
        const fetchInitialData = async () => {
          try {
            const response = await apiService('customers', "GET");
            setCustomers(response.data);
      
            if (id) {
              await fetchUserData(); // Fetch user data only after customers
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
      
        fetchInitialData();
      }, [id]);
      

    const toggleCustomer = async (customerId) => {
    }
      const handleSubmit = async (values) => {
        const { name, email } = values;
        console.log('Form submitted:', { name, email, selectedCustomers });
         // Validate name length
          if (!name || name.length < 2 || name.length > 50) {
            toast.error("Name must be between 3 and 50 characters");
            return;
        }

        // Validate email format using a regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email || !emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        try {
            const userData = {
                name,
                email,
                customers: selectedCustomers,
            };
            let response ;
            if (id) {
              // 🔁 Update User
              response = await apiService(`users/update-user/${id}`, 'PUT', userData);
              toast.success("User updated successfully!");
            } else {
              // ➕ Add New User
              response = await apiService('users/add-user', 'POST', userData);
              toast.success("User added successfully!");
            }
            console.log('User added successfully:', response.data);
            // Reset form fields
            setName('');
            setEmail('');
            setSelectedCustomers([]);
            form.resetFields();
          
            navigate("/users"); // Redirect right away
        } catch (error) {
            console.error('Error adding user:', error);
            toast.error(error.message || "Error adding user");
        }
    }

      return(
        <div className="bg-white p-6">
  
      <Form layout="vertical" onFinish={handleSubmit}  form={form} >

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter the user's name" }]}
        >
          <Input size="large" placeholder="Full Name" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter the user's email" }, {
            type: "email",
            message: "Please enter a valid email address",
          },]}
        >
          <Input size="large" placeholder="Email" />
        </Form.Item>

        <Form.Item label="Customers">
          <Select
            mode="multiple"
            size="large"
            placeholder="Select customers"
            onChange={(values) => setSelectedCustomers(values)}
            value={selectedCustomers} // ✅ bind the selected values
          >
            {customers.map((customer) => (
              <Option key={customer.id} value={customer.id}>
                {customer.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
    </div>

   
    {/* Submit Button */}
    <div className="flex justify-end space-x-4 gap-4 mt-6">
      <button
        type="button"
        onClick={() => navigate("/users")}
        style={{color: "#fff"}}
        className="text-right cursor-pointer btn  btn-sm px-6 bg-[#287DD1] text-white text-lg py-3 rounded-md   transition mr-4"
      >
        Cancel
      </button>  
      
        <button
        type="submit" 
        style={{color: "#fff"}}
        className="cursor-pointer text-right btn  btn-sm px-6   bg-[#107C41]  text-white text-lg py-3 rounded-md   transition"
        >
        {id ? "Update User" : "Add User"}
        </button>
    </div>
    </Form>

  
</div>

      )
}
export default AddUser